import { useCallback } from 'react';

import { AssetOverlayOutlined } from '../Icons/AssetOverlayIcon';
import { StyledButton } from '../ImageViewer.style';

type AssetOverlayToolProps = {
  onChange: (data: any) => void;
  value?: boolean;
  disabled?: boolean;
};

export const AssetOverlayTool: React.FunctionComponent<AssetOverlayToolProps> = ({
  onChange,
  value = false,
  disabled = false,
}) => {
  const handleClick = useCallback(() => {
    onChange({ assetOverlay: !value });
  }, [value, onChange]);

  return (
    <StyledButton
      data-testid="image-controls-asset-overlay"
      title="Asset Overlay"
      type={value ? 'primary' : 'default'}
      onClick={handleClick}
      disabled={disabled}
      icon={<AssetOverlayOutlined />}
    />
  );
};
